import { Mutation } from 'vuex'
import { VideoWidgetState } from '../types'

const setProgress: Mutation<VideoWidgetState> = (state, payload: number) => {
  state.progress = payload
}

export default setProgress
